import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.recordList.loading;
export const selectErrorMessage = (state: RootState) => state.recordList.error;
export const recordListDataResponse = (state: RootState) =>
  state.recordList.recordListResponse;
